import React from 'react';
import styled from 'styled-components';
import Top_Menu from '../main/Top_Menu';
import Bottom_Menu from '../main/Bottom_Menu';
import lang from '../language/Eng_eng.json';

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding-top: 100px; /* Space for Top_Menu */
  background-color: #F3EFE6;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

const GallerySection = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  height: 400px;
  gap: 15px;
  padding: 0 15px;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

const GalleryImage = styled.div<{ bgImage: string }>`
  flex: 1;
  background-image: url(${props => props.bgImage});
  background-size: cover;
  background-position: center;
  background-color: #e0dcd2; /* Fallback color for dummy images */
  height: 100%;
  
  @media (max-width: 768px) {
    height: 300px;
  }
`;

const MiddleImage = styled(GalleryImage)`
  flex: 1.5; /* The middle image appears slightly wider in the design */
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 80px 5% 40px;
  color: #5C4033;
`;

const Title = styled.h1`
  font-family: 'EB Garamond', serif;
  font-size: 2.5rem;
  font-weight: 500;
  letter-spacing: 0.12rem;
  margin-bottom: 30px;
`;

const Description = styled.p`
  font-size: 1.05rem;
  line-height: 1.8;
  max-width: 900px;
  opacity: 0.85;
  margin-bottom: 50px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 80px;

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    padding: 0 20px;
  }
`;

const MenuButton = styled.button`
  padding: 15px 50px;
  background-color: transparent;
  border: 1px solid #5C4033;
  color: #5C4033;
  font-family: 'EB Garamond', serif;
  font-size: 1.0rem;
  letter-spacing: 0.18rem;
  text-transform: uppercase;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 200px;

  &:hover {
    background-color: #5C4033;
    color: #F3EFE6;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const Menu: React.FC = () => {
  return (
    <Container>
      <Top_Menu />
      
      <GallerySection>
        {/* Placeholder images - the user will replace these */}
        <GalleryImage bgImage="/image/Menu_img1.webp" />
        <MiddleImage bgImage="/image/Menu_img2.webp" />
        <GalleryImage bgImage="/image/Menu_img3.webp" />
      </GallerySection>

      <TextSection>
        <Title>{lang.menuPage.title}</Title>
        <Description>{lang.menuPage.description}</Description>
      </TextSection>

      <ButtonContainer>
        <MenuButton onClick={() => window.location.href = 'https://vuzagroup.synology.me/allta_menu/index.html'}>
          {lang.menuPage.buttons.food}
        </MenuButton>
        <MenuButton>{lang.menuPage.buttons.beverage}</MenuButton>
      </ButtonContainer>

      <Bottom_Menu />
    </Container>
  );
};

export default Menu;
